module.exports = __webpack_public_path__ + "img/Front_Mobile_Transport.jpg";